import { FundingSource } from "admin/types/interfaces/funding";
import { SWRConfiguration } from "swr";
import { useV1List } from "~/hooks/useV1List";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const useFundingSources = (enabled = true, options?: SWRConfiguration) => {
  const url = enabled ? `${ACCESS_CONTROLLER_V1}/funding-sources` : null;
  return useV1List<FundingSource>(url, { shouldCamelize: true, ...options });
};

export default useFundingSources;
